/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListJsonWebKeysSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListJsonWebKeysRequest = {
  /**
   * The ID of the key set whose keys to list.
   */
  setId: string;
  /**
   * Also return revoked keys.
   */
  includeRevoked?: boolean | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListJsonWebKeysSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListJsonWebKeysSecurity$outboundSchema: z.ZodMiniType<
  ListJsonWebKeysSecurity$Outbound,
  ListJsonWebKeysSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listJsonWebKeysSecurityToJSON(
  listJsonWebKeysSecurity: ListJsonWebKeysSecurity,
): string {
  return JSON.stringify(
    ListJsonWebKeysSecurity$outboundSchema.parse(listJsonWebKeysSecurity),
  );
}

/** @internal */
export type ListJsonWebKeysRequest$Outbound = {
  set_id: string;
  include_revoked: boolean;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListJsonWebKeysRequest$outboundSchema: z.ZodMiniType<
  ListJsonWebKeysRequest$Outbound,
  ListJsonWebKeysRequest
> = z.pipe(
  z.object({
    setId: z.string(),
    includeRevoked: z._default(z.boolean(), false),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      setId: "set_id",
      includeRevoked: "include_revoked",
      gramSession: "Gram-Session",
    });
  }),
);

export function listJsonWebKeysRequestToJSON(
  listJsonWebKeysRequest: ListJsonWebKeysRequest,
): string {
  return JSON.stringify(
    ListJsonWebKeysRequest$outboundSchema.parse(listJsonWebKeysRequest),
  );
}
